import { DataOverview } from "@models/DataOverview";
import OVERVIEW_DATA_12_2024 from "@data/OverviewData_12-2024.json";
import OVERVIEW_DATA_06_2025 from "@data/OverviewData_06-2025.json";
import OVERVIEW_DATA_11_2025 from "@data/OverviewData_11-2025.json";
import OVERVIEW_DATA_01_2026 from "@data/OverviewData_01-2026.json";
import OVERVIEW_DATA_06_2026 from "@data/OverviewData_06-2026.json";
import MAP_DATA_12_2024 from "@data/MapData_12-2024.json";
import MAP_DATA_06_2025 from "@data/MapData_06-2025.json";
import MAP_DATA_11_2025 from "@data/MapData_11-2025.json";
import MAP_DATA_01_2026 from "@data/MapData_01-2026.json";
import MAP_DATA_06_2026 from "@data/MapData_06-2026.json";
import { DataRegions } from "@models/DataRegions";

const OVERVIEW_DATA_MAP: Record<string, DataOverview> = {
  "12/2024": OVERVIEW_DATA_12_2024,
  "06/2025": OVERVIEW_DATA_06_2025,
  "11/2025": OVERVIEW_DATA_11_2025,
  "01/2026": OVERVIEW_DATA_01_2026,
  "06/2026": OVERVIEW_DATA_06_2026,
};

const MAP_DATA_MAP: Record<string, DataRegions[]> = {
  "12/2024": MAP_DATA_12_2024,
  "06/2025": MAP_DATA_06_2025,
  "11/2025": MAP_DATA_11_2025,
  "01/2026": MAP_DATA_01_2026,
  "06/2026": MAP_DATA_06_2026,
};

export const fetchOverviewData = async (
  year: string,
): Promise<DataOverview> => {
  return new Promise((resolve) => {
    const data = OVERVIEW_DATA_MAP[year] || OVERVIEW_DATA_06_2025;
    setTimeout(() => resolve(data), 500);
  });
};

export const fetchMapData = async (year: string): Promise<DataRegions[]> => {
  return new Promise((resolve) => {
    const data = MAP_DATA_MAP[year] || MAP_DATA_11_2025;
    setTimeout(() => resolve(data), 500);
  });
};
